































import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class OrderInfo extends Vue {
	@Prop({
		type: Object,
		required: false,
		default: () => {
			return {}
		}
	})
	private orderData!: any
	@Prop({
		type: Array,
		required: false,
		default: () => {
			return []
		}
	})
	private orderAttachments!: any
	@Prop({
		type: Number,
		required: false,
		default: () => {
			return {}
		}
	})
	private numbers!: any
	@Prop({
		type: Boolean,
		required: false,
		default: () => {
			return {}
		}
	})
	private showImgState!: any
	private isBillState (state: any) {
		return (this as any).$fxStateMiddleware.stateIs('stateAccount')(state)(this.orderData.bill_state)
	}
	private onImgUpload (file: any) {
		this.onImgUploadHandler(file).then(() => {
			this.$emit('on-img-refresh')
		})
	}
	private onImgUploadHandler (file: any) {
		const params = {
			file,
			id: this.orderData.id,
			number: this.numbers
		}
		return (this as any).$fxHttp.requestFile({
			url: '/business/bill/uploadEnclosure',
			data: params
		}).then((res: any) => {
			if (res.success) {
				(this as any).$fxMessage.success('上传附件成功')
				return Promise.resolve()
			} else {
				(this as any).$fxMessage.error(res.cause)
			}
		})
	}
	private onImgDel (imgId: string) {
		(this as any).$fxConfirm('是否确定删除此附件？').then(() => {
			this.onImgDelHandler(imgId).then(() => {
				this.$emit('on-img-refresh')
			})
		})
	}
	private onImgDelHandler (imgId: string) {
		const params = {
			id: imgId
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/bill/deleteEnclosure',
			data: params
		}).then(() => {
			(this as any).$fxMessage.success('删除附件成功')
			return Promise.resolve()
		})
	}
}
